module.exports = __webpack_public_path__ + "img/雙子座.dc4d9407.svg";